<template>
  <div
    v-if="content"
    class="flex flex-col space-y-4 border-t border-t-anthracite-300 py-7"
  >
    <template
      v-for="entry in content.fields.content ?? []"
      :key="entry?.sys?.contentType?.sys?.id"
    >
      <CMSText
        v-if="entry?.sys?.contentType?.sys?.id === 'cmsText'"
        :blok="entry?.fields?.body ?? null"
      />
      <component
        :is="getComponentName(entry?.sys?.contentType?.sys?.id) ?? 'div'"
        v-else
        :blok="entry"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { TypePostListingPageSkeleton } from '../types'
import { useCMSBySlug } from '../composables/useCMS'
import { useContentfulEditor } from '../composables/useContentfulEditor'
import { CMSText } from '#components'
import { getComponentName } from '~/modules/cms/utils/helpers'

const { categoryId, slug } = defineProps<{
  categoryId: number
  slug?: string
}>()

const { data } = await useCMSBySlug<TypePostListingPageSkeleton>(
  `listing-page-teaser`,
  computed(() => ({
    content_type: 'postListingPage',
    // NOTE: We need to pass both the `c/` path, as well as the prefix `c-` plus
    // the selected categoryID to the useCMSBySlug composables.
    // Contentful requires also to set `c/c-{selectedCategory} to be set as `Slug`
    // within the related story.
    // This allows the Contentful Preview functionality to properly work.
    'fields.slug[match]': slug ?? `c/c-${categoryId}`,
  })),
)

useContentfulEditor<TypePostListingPageSkeleton>(data)

const content = computed(() => data.value)

defineOptions({ name: 'CMSPostListingPage' })
</script>
